import styled from 'styled-components'
import { Title } from 'components/IndexLayout'

export const Wrapper = styled.div`
  max-width: 444px;
  margin: auto;

  ${Title} {
    margin-top: 32px;
  }
`

export const PlanPickerWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
`

export const EstimatedPriceText = styled.div`
  max-width: 320px;
  margin: 0 auto 64px;

  font-size: 0.8125rem;
  color: ${({ theme }) => theme.colors.text.dark.secondary};
  text-align: center;

  > b {
    font-weight: 500;
    color: ${({ theme }) => theme.colors.text.dark.primary};
  }
`

export const ErrorMessage = styled.p`
  color: ${({ theme }) => theme.colors.text.dark.secondary};
  font-size: ${({ theme }) => theme.fontSizes.small};
`
